import { z } from 'zod';
import { BRANCH_CODES } from '../types/branches.js';
import { REQUEST_KINDS, URGENCY_LEVELS } from '../types/enums.js';

export const BranchCodeSchema = z.enum(BRANCH_CODES);
export const RequestKindSchema = z.enum(REQUEST_KINDS);
export const UrgencySchema = z.enum(URGENCY_LEVELS);

export const RequestItemSchema = z.object({
  sku: z.string().min(1),
  qty: z.number().int().positive(),
  note: z.string().max(500).optional(),
});
export type RequestItemInput = z.infer<typeof RequestItemSchema>;

export const CreateBranchRequestSchema = z
  .object({
    kind: RequestKindSchema,
    from_branch: BranchCodeSchema.optional(),
    source_branch: BranchCodeSchema.optional(),
    urgency: UrgencySchema.default('normal'),
    reason: z.string().max(1000).optional(),
    items: z.array(RequestItemSchema).min(1),
  })
  .refine(
    (data) => {
      if (data.kind === 'transfer_request') return !!data.source_branch;
      return true;
    },
    { message: 'source_branch is required for transfer_request', path: ['source_branch'] }
  );
export type CreateBranchRequestInput = z.infer<typeof CreateBranchRequestSchema>;

export const ReviewRequestSchema = z.object({
  action: z.enum(['approve', 'reject']),
  note: z.string().max(1000).optional(),
});
export type ReviewRequestInput = z.infer<typeof ReviewRequestSchema>;

export const CommentSchema = z.object({
  body: z.string().min(1).max(2000),
});
export type CommentInput = z.infer<typeof CommentSchema>;
